import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import style from "../styles/scrollProgress.module.css";

// Gradient bar pinned under the navbar that tracks reading position.
const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const width = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return <motion.div className={style.bar} style={{ scaleX: width }} />;
};

export default ScrollProgress;
